import { NEWBUILDING_PUSH_TO_CALL } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export function getIsPushToCallEnabled(state: IApplicationState) {
  return state.isPushToCallEnabled && getIsPushToCallExperimentActive(state);
}

function getIsPushToCallExperimentActive(state: IApplicationState) {
  const { experiments } = state;

  return isAbUseExperimentActive(experiments, NEWBUILDING_PUSH_TO_CALL, 'enabled');
}
